function mainRender() {
    $(function () {
        $('#root').css('zoom', 'normal')
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)

        window.addEventListener(
            'resize',
            (function () {
                var timer
                return function () {
                    if (timer) clearTimeout(timer)
                    timer = setTimeout(function () {
                        $('#root').css('zoom', 'normal')
                        let scale = document.body.clientWidth / 1080
                        $('#root').css('zoom', scale)
                    }, 100)
                }
            })()
        )
        // 头部固定
        $('header').addClass('stiky')
        $(document).scroll(function (e) {
            var beforScrollTop = $(document).scrollTop()
            setTimeout(function () {
                $('header').addClass('stiky')
            }, 50)
        })
        // 走马灯
        var stringEl = $('.str3').liMarquee({
            scrollamount: 100,
            loop: -1,
        })
        // 展开
        var show = false
        $('.sp-shows').click(function () {
            show = !show
            $('.sp-hide-wraper').toggle(100)
            if (show == true) {
                $('.sp-shows').addClass('open')
            } else {
                $('.sp-shows').removeClass('open')
            }
        })
        $('.link-btn').click(function () {
            let id = $(this).attr('data-id')
            let num = $(this).parent().find('.sp-number input').val()
            window.location.href = '/cart/' + id + ':' + num
        })
        $('#2').change(function () {
            var number = Number($('#2').val())
            $(this)
                .parents()
                .parents()
                .siblings('.sp-price')
                .children('span')
                .children('.new')
                .html((number * Number(window.product[0].price / 100)).toFixed(2))
            $(this)
                .parents()
                .parents()
                .siblings('.sp-price')
                .children('em')
                .children('.old')
                .html((number * Number(window.product[0].compare_at_price / 100)).toFixed(2))
        })
        $('#3').change(function () {
            var number = Number($('#3').val())
            $(this)
                .parents()
                .parents()
                .siblings('.sp-price')
                .children('span')
                .children('.new')
                .html((number * Number(window.product[1].price / 100)).toFixed(2))
            $(this)
                .parents()
                .parents()
                .siblings('.sp-price')
                .children('em')
                .children('.old')
                .html((number * Number(window.product[1].compare_at_price / 100)).toFixed(2))
        })
        // 数字框初始化
        alignmentFns.initialize()
        new Swiper('.mySwiper', {
            loop: true,
            autoplay: {
                delay: 3000,
                stopOnLastSlide: false,
                disableOnInteraction: true,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    switch (index) {
                        case 0:
                            text = 'Motor'
                            break
                        case 1:
                            text = 'Fläktblad'
                            break
                    }
                    return '<span class="' + className + '">' + text + '</span>'
                },
            },
        })
        $(function () {
            // 倒计时的事件
            // 当前时间
            TimeDown(43200000)
            /*
             时间倒计时
             TimeDown.js
             */
            function TimeDown(value) {
                //倒计时的总秒数
                var totalSeconds = parseInt(value / 1000)
                //取模（余数）
                var modulo = totalSeconds % (60 * 60 * 24)
                //小时数
                var hours = Math.floor(modulo / (60 * 60))
                modulo = modulo % (60 * 60)
                //分钟
                var minutes = Math.floor(modulo / 60)
                //秒
                var seconds = modulo % 60

                hours = hours.toString().length == 1 ? '0' + hours : hours
                minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
                seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

                //输出到页面
                $('.hours').html(hours)
                $('.minutes').html(minutes)
                $('.seconds').html(seconds)
                //延迟一秒执行自己
                if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
                } else {
                    setTimeout(function () {
                        TimeDown(value - 1000)
                    }, 1000)
                }
            }
        })
    })
    function addCart() {
        // 加入购物车
        $('#addCart').click(function () {
            // do something here
            var number = Number($('.buy-car span').html()) + Number($('#2').val())
            $('.buy-car span').html(number)
            var img = $('.sp-pro-img img')
            var flyer = img[0].cloneNode(true)
            flyer.classList.add('clone')
            $('.sp-part5').append(flyer)
            $('.clone').css({
                width: '796px',
                height: '711px',
                position: 'fixed',
                top: img[0].offsetTop,
                left: img.offset().left,
                'z-index': '99',
            })
            var offset = $('.buy-car')[0].getBoundingClientRect()
            $('.buy-car').addClass('shake')
            setTimeout(() => {
                $('.buy-car').removeClass('shake')
            }, 1000)
            let finish = $('.buy-car')
            $('.clone').animate(
                {
                    top: offset.top + finish.height() / 2 / 2,
                    left: offset.left + finish.width() / 2,
                    width: 50, // 结束时的大小，根据需要调整
                    height: 50, // 结束时的大小，根据需要调整
                    opacity: 0.4,
                },
                1000,
                'linear',
                function () {
                    $(this).animate(
                        {
                            width: 0,
                            height: 0,
                            opacity: 0,
                        },
                        0,
                        function () {
                            $(this).detach() // 完成动画后移除克隆的图片
                        }
                    )
                }
            )
        })
    }
    function lazyLoadImages() {
        // 懒加载
        const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
        const config = {
            rootMargin: '0px 0px 1300px 0px',
            threshold: 0,
        }

        const lazyLoadObserver = new IntersectionObserver(function (
            entries,
            observer
        ) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // 当图片进入视口时
                    const image = entry.target
                    const dataSrc = image.getAttribute('data-src')
                    image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                    lazyLoadObserver.unobserve(image) // 停止观察该图片
                }
            })
        },
            config)

        images.forEach(function (image) {
            lazyLoadObserver.observe(image) // 开始观察每个图片
        })
    }

    function preloadImages(imageArray) {
        // 预加载
        // 检查数组数据结构
        if (Array.isArray(imageArray[0])) {
            // 处理二维数组
            imageArray.forEach((subArray) => {
                subArray.forEach((url) => {
                    const img = new Image()
                    img.src = url
                })
            })
        } else {
            // 处理一维数组
            imageArray.forEach((url) => {
                const img = new Image()
                img.src = url
            })
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        lazyLoadImages()

        // preloadImages(imagesOneDim)
        // preloadImages(imagesTwoDim)

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault() // 阻止默认的跳转行为
                // var targetElement = document.getElementById('shopping');
                // if (targetElement) {
                //     targetElement.scrollIntoView({ behavior: 'smooth' });
                // } // 方式一
                const targetElement = document.getElementById('shopping') // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop - $('header').height()
                window.scroll({
                    top: offsetTop * $('div#root').css('zoom'),
                    behavior: 'smooth', // 使用 smooth 实现平滑滚动
                }) // 方式二
            })
        })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
        console.log('Android')
    } else if (isIOS) {
        console.log('iOS')
    } else if (isPC) {
        console.log('PC')
    } else {
        $('.sp_system').css('letter-spacing', '-4px')
    }

    var alignmentFns = {
        inputs: [],
        init: function (input, step, max, min, digit) {
            var width = 374
            var height = 90
            var _this = this
            width += 3

            input.attr('readonly', 'readonly')
            //设置不分样式
            input.css('border', 'none')
            input.css('width', width - height * 2 - 2)
            input.css('height', height)
            input.css('padding', '0px')
            input.css('margin', '0px')
            input.css('text-align', 'center')
            input.css('vertical-align', 'middle')
            input.css('line-height', height + 'px')
            input.css('background-color', 'transparent')

            //添加左右加减号
            input.wrap(
                "<div id = '" +
                input.attr('id') +
                "div' style = '  border-radius: 14px;overflow:hidden;display: flex;width:" +
                width +
                'px;height:' +
                height +
                "px;border: 4px solid rgba(15, 15, 15, .43);'></div>"
            )
            input.before(
                "<div id = '" +
                input.attr('id') +
                "l'  onselectstart = 'return false;' style = 'font-size:56px;color:rgba(124, 124, 124, 1);-moz-user-select:none;cursor:pointer;text-align:center;width:" +
                height +
                'px;height:' +
                height +
                'px;line-height:' +
                height +
                "px;float:left;;color:#666666;'>—</div>"
            )
            input.after(
                "<div id = '" +
                input.attr('id') +
                "r'  onselectstart = 'return false;' style = '-moz-user-select:none;cursor:pointer;text-align:center;font-size:56px;color:rgba(124, 124, 124, 1);width:" +
                height +
                'px;height:' +
                height +
                'px;line-height:' +
                height +
                "px;float:right;color:#666666;'> + </div>"
            )
            //左右调用执行
            $('#' + input.attr('id') + 'l').click(function () {
                _this.execute(input, step, max, min, digit, true)
            })
            $('#' + input.attr('id') + 'r').click(function () {
                _this.execute(input, step, max, min, digit, false)
            })
        },
        execute: function (input, step, max, min, digit, _do) {
            var val = parseFloat(this.format(input.val(), digit))
            var ori = val
            if (_do) val -= step
            if (!_do) val += step
            if (val < min) {
                val = min
            } else if (val > max) {
                val = max
            }
            input.val(this.format(val, digit)).change()
        },
        format: function (val, digit) {
            if (isNaN(val)) {
                val = 0
            }
            return parseFloat(val).toFixed(digit)
        },
        // 类型
        data: {
            default_data: {
                step: 0.1,
                min: 0,
                max: 99,
                digit: 1,
            },
        },
        // 初始化
        initialize: function () {
            //使用控件必须有以下属性或者引用alignment类
            var inputs = $(
                'input[user_data], input[data-digit], input[data-step], input[data-min], input[data-max], input.alignment'
            )

            inputs.each(function () {
                // 记录原始input代码
                alignmentFns.inputs.push(this.outerHTML)
                //预设值数据选择
                var data = alignmentFns.data

                var user_data = eval('data.' + $(this).attr('user_data'))
                if (user_data == null) {
                    user_data = JSON.parse(JSON.stringify(data.default_data))
                }

                var digit = $(this).data('digit')
                if (digit != null && !isNaN(parseFloat(digit))) {
                    digit = parseFloat(digit).toFixed(0)
                    user_data.digit = parseFloat(digit)
                }

                var step = $(this).data('step')
                if (step != null && !isNaN(parseFloat(step))) {
                    user_data.step = parseFloat(step)
                }
                var min = $(this).data('min')
                if (min != null && !isNaN(parseFloat(min))) {
                    user_data.min = parseFloat(min)
                }

                var max = $(this).data('max')
                if (max != null && !isNaN(parseFloat(max))) {
                    user_data.max = parseFloat(max)
                }
                //自动装载
                alignmentFns.init(
                    $(this),
                    user_data.step,
                    user_data.max,
                    user_data.min,
                    user_data.digit
                )

                var data_edit = $(this).data('edit')
                if (data_edit) {
                    $(this).attr('readonly', null)
                }
            })
        },
        destroy: function () {
            var inputs = this.inputs
            $.each(inputs, function (index, obj) {
                var input = $(obj)[0]
                var id = input.id
                $('#' + id + 'div').replaceWith(input)
            })
        },
        // 动态添加类型
        createType: function (types) {
            $.each(types, function (index, obj) {
                alignmentFns.data[obj.type] = obj.data
            })
        },
    }


}

mainRender()
